export class CustomFormFieldOption {
  public label: string;
  public value: string;
}
